import { HeaderContainer, HeaderTitle } from 'twyne-new.ui';

import { useGrid } from '../Grid';

import ButtonCollapse from './ButtonCollapse';

export default function HeaderContainerGrid({ title, children, titleClass = '' }) {
  const grid = useGrid()
  const renderButtonCollapse = !grid?.definitions ? true : grid.definitions.menuToggle !== undefined ? grid.definitions.menuToggle : true

  return <>
    <HeaderContainer>
      <div className='justify-between items-center gap-4 flex'>
        {renderButtonCollapse && <ButtonCollapse />}
        <HeaderTitle className={titleClass}>
          {title}
        </HeaderTitle>
      </div>
      {children}
    </HeaderContainer>
  </>
}
